import React__default from 'react';
import { Price } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { useIntl } from '@grandvisionhq/state';

const SubscriptionDailyIntervalPriceCaption = ({ price , isCentAmount , priceInterval  })=>{
    const { getFormattedLabel , currency  } = useIntl();
    return /*#__PURE__*/ React__default.createElement(Text, {
        component: "span",
        variant: "body"
    }, ' (', /*#__PURE__*/ React__default.createElement(Price, {
        value: price,
        currency: currency,
        centAmount: isCentAmount
    }), ' / ', getFormattedLabel('common.frequency.perDays', {
        labelData: {
            days: priceInterval
        }
    }), ')');
};

export { SubscriptionDailyIntervalPriceCaption };
//# sourceMappingURL=SubscriptionDailyIntervalPriceCaption.js.map
